import React, { useState } from 'react';
import { toast } from 'react-toastify';
import api, { getErrorMessage } from '../../services/api';
import { PROCEDURE_KIND_LABELS, REGION_LABELS } from '@claimup/shared/helpers/judicial-pricing';

/**
 * El procedimiento judicial del expediente (docs/precios-judicial-plan.md): si es
 * un monitorio o un verbal, en qué región va la tasa y la tasa real cuando llega
 * el anexo del despacho. Con esto se factura la demanda el mes en que se
 * presenta. Lo cambian el despacho y el admin.
 */
const JudicialProcedureCard = ({ expedientId, procedure, onChange }) => {
  const [form, setForm] = useState({
    kind: procedure?.kind || '',
    region: procedure?.region || '',
    court_fee: procedure?.court_fee ?? '',
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/expedients/${expedientId}/procedimiento-judicial`, {
        kind: form.kind || null,
        region: form.region || null,
        court_fee: form.court_fee === '' ? null : Number(form.court_fee),
      });
      onChange?.(data.data.judicial_procedure);
      toast.success('Procedimiento guardado');
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  const select = 'rounded-lg border-gray-300 text-sm';

  return (
    <div className='mt-3 rounded-lg border border-slate-200 p-3 text-sm space-y-2'>
      <p className='font-medium text-slate-700'>Procedimiento judicial</p>
      <div className='flex flex-wrap items-end gap-3'>
        <label className='flex flex-col text-slate-600'>
          Tipo
          <select
            aria-label='Tipo de procedimiento'
            value={form.kind}
            onChange={e => setForm(f => ({ ...f, kind: e.target.value }))}
            className={select}
          >
            <option value=''>Sin indicar</option>
            {Object.entries(PROCEDURE_KIND_LABELS).map(([v, l]) => (
              <option key={v} value={v}>
                {l}
              </option>
            ))}
          </select>
        </label>
        <label className='flex flex-col text-slate-600'>
          Región de la tasa
          <select
            aria-label='Región de la tasa'
            value={form.region}
            onChange={e => setForm(f => ({ ...f, region: e.target.value }))}
            className={select}
          >
            <option value=''>Por el código postal del deudor</option>
            {Object.entries(REGION_LABELS).map(([v, l]) => (
              <option key={v} value={v}>
                {l}
              </option>
            ))}
          </select>
        </label>
        <label className='flex flex-col text-slate-600'>
          Tasa real (€)
          <input
            type='number'
            min='0'
            step='0.01'
            aria-label='Tasa real'
            placeholder='La de la tabla'
            value={form.court_fee}
            onChange={e => setForm(f => ({ ...f, court_fee: e.target.value }))}
            className='w-32 rounded-lg border-gray-300 text-sm'
          />
        </label>
        <button
          type='button'
          onClick={save}
          disabled={saving}
          className='rounded-lg bg-blue-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50'
        >
          {saving ? 'Guardando…' : 'Guardar'}
        </button>
      </div>
    </div>
  );
};

export default JudicialProcedureCard;
